export enum PaymentStatus {
  Pending = "Pending",
  Failure = "Failure",
  Success = "Success",
}

export enum PaymentSuccessCodes {
  Authorised = "Authorised",
  Received = "Received",
  Claimed = "Claimed", // This is a custom code for our use case where the user "claims" a 0 Euro order without a payment
}

export enum PaymentFailureCodes {
  Refused = "Refused",
  Error = "Error",
  Cancelled = "Cancelled",
  ClaimError = "ClaimError",
}

export enum PaymentProcessingCodes {
  Processing = "Processing",
}

export type PaymentCompleted = {
  resultCode: string;
  refusalReasonCode: string | null;
  sessionData?: string;
};

export type PaymentRequest = {
  clientStateDataIndicator: boolean;
  paymentMethod: { issuer: string; type: string };
  riskData: { clientData: string };
};

export type PaymentDetailsData = {
  details: {
    billingToken?: string | null;
    facilitatorAccessToken?: string | null;
    orderID?: string | null;
    payerID?: string | null;
    paymentID?: string | null;
    paymentSource?: string | null;
    redirectResult?: string | null;
  };
  paymentData?: string | null;
};

export type PaymentSession = {
  id: string;
  sessionData?: string;
};
